import React, { useEffect, useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import axios from 'axios';
import { endPoints } from "../../Constants";
import { useTranslation,Trans  } from 'react-i18next';
const Articles = () => {
    const [myMedia, setMedia] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const articlesPerPage = 5;
 const { t,i18n } = useTranslation();
    useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`${endPoints.news}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                setMedia(res.data);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    // Pagination Logic
    const totalPages = Math.ceil(myMedia.length / articlesPerPage);
    const startIndex = (currentPage - 1) * articlesPerPage;
    const endIndex = startIndex + articlesPerPage;
    const currentArticles = myMedia.slice(startIndex, endIndex);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <section className="lyt-section custom-margin-top">
                <div className="container">
                    <div className="bs-breadcrumb">
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{t('mediaAndNews')}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>

                    <div className="heading-wrapper">
                        <div>
                            <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">
                                {t('mediaAndNews')}
                            </h2>
                            <p className="bs-para typgrey" data-aos="fade-in" data-aos-delay="300">
                                {t('mediaSubTitle')}
                            </p>
                        </div>
                    </div>

                    <h2 className="bs-heading typ-32 typ600">{t('newsArticles')}</h2>

                    <div className="card-wrapper">
                        {currentArticles.map((item, index) => {
                            const { newsMediaShortDes,newsMediaShortDesMr, newsMediaLongDes,newsMediaLongDesMr, newsMediaDate, newsMediaImageURL, readMoreContent ,newsMediaPublishedByMr } = item;
                            const NewsMediaShortDes = i18n.language === 'mr' ? newsMediaShortDesMr : newsMediaShortDes;
                            const NewsMediaLongDes = i18n.language === 'mr' ? newsMediaLongDesMr : newsMediaLongDes;
                            // const formattedDate = new Intl.DateTimeFormat(i18n.language === 'mr' ? 'mr-IN' : 'en-IN', {
                            //                                         year: 'numeric',
                            //                                         month: 'long',
                            //                                         day: 'numeric',
                            //                                         weekday: 'long'
                            //                                         }).format(new Date(newsMediaDate));

                            return (
                                <div className="bs-card typ-media" data-aos="fade-in" data-aos-delay="200" key={index}>
                                    <div className="box-img">
                                        <img
                                            className="img-fluid"
                                            src={newsMediaImageURL}
                                            alt="Event 1"
                                            width={384}
                                            height={297}
                                        />
                                    </div>
                                    <div className="set-contentBox">
                                        <div className="box-text">
                                            <div className="title">{NewsMediaShortDes}</div>
                                            <div className="discription">{NewsMediaLongDes}</div>
                                            <div className="new-flex">
                                                <div>
                                                    <div className="date">{newsMediaDate}</div>
                                                </div>
                                                <a
                                                    className="bs-btn typexplore"
                                                    href={readMoreContent}
                                                    aria-label="Navigate to Contact Us page"
                                                >
                                                    {t('exploreMore')} <span className="icon icon-right-arrow"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <nav aria-label="Page navigation" className="bs-pagination">
                            <ul className="pagination">
                                <li
                                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <a className="page-link">Previous</a>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li
                                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                        key={index}
                                        onClick={() => handlePageChange(index + 1)}
                                    >
                                        <a className="page-link">{index + 1}</a>
                                    </li>
                                ))}
                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <a className="page-link">Next</a>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </section>
        </>
    );
};

export default Articles;
